import React from 'react';
import PropTypes from 'prop-types';
import OutlinedTextField from '../textFields/OutlinedTextField';
import SelectDropdown from '../SelectDropdown/SelectDropdown';
import DatePicker from '../../shared/DatePicker/DatePicker';
import StarRating from '../../shared/StarRating';
import Toggle from '../../shared/Toggle';
import { activities } from '../../../utils/activity_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import styles from './styles/styles.module.scss';

const TrackUploadFields = props => {
  const handleTextChange = e => {
    const { name, value } = e.currentTarget;
    const payload = { [name]: value };

    props.updateTrackForm(payload);
  };

  const handleActivityChange = e => {
    const value = e.currentTarget.dataset.value;
    const activity = activities.find(active => active.value === value);
    const payload = { activity };

    props.updateTrackForm(payload);
  };

  const handleDateChange = date => {
    props.updateTrackForm({ date });
  };

  const handleRatingChange = (e, rating) => {
    e.preventDefault();
    props.updateTrackForm({ rating });
  };

  const togglePrivacy = e => {
    const isPrivate = e.currentTarget.checked;
    props.updateTrackForm({ isPrivate });
  };

  return (
    <div className={styles.formContainer}>
      <div className={`${styles.formSection} ${styles.topField}`}>
        <OutlinedTextField
          label={StringConstantsMixin.strings.TRACK_DETAIL.RECORDING_TITLE}
          value={props.name}
          name="name"
          changeHandler={handleTextChange}
        />
        <textarea
          className={styles.textArea}
          value={props.description}
          placeholder={StringConstantsMixin.strings.TRACK_DETAIL.RECORDING_DESCRIPTION}
          onChange={handleTextChange}
          name="description"
        />
      </div>
      <div className={`${styles.formSection} ${styles.alignedLabel} ${styles.spaceBetween}`}>
        <div className={styles.labelName}>{StringConstantsMixin.strings.ACTIVITY}*</div>
        <div className={styles.dropdowns}>
          <SelectDropdown options={activities} handleChange={handleActivityChange} defaultItem={props.activity} isMobile={props.isMobile} slim />
          <DatePicker date={props.date} onChange={handleDateChange} locale={props.locale} slim />
        </div>
      </div>
      <div className={`${styles.formSection} ${styles.alignedLabel}`}>
        <div className={styles.labelName}>{StringConstantsMixin.strings.RATING}*</div>
        <div className={styles.starsContainer}>
          <StarRating handler={handleRatingChange} config={props.rating} iconClassName={styles.starRatingIconClass} />
        </div>
      </div>
      <div className={`${styles.formSection} ${styles.spaceBetween} ${styles.privacyContainer}`}>
        <div className={styles.labelName}>{StringConstantsMixin.strings.PRIVATE}</div>
        <div>
          <Toggle inputId="listPrivacyToggle" onChange={togglePrivacy} checked={props.isPrivate} defaultChecked={props.private} />
        </div>
      </div>
    </div>
  );
};

TrackUploadFields.propTypes = {
  updateTrackForm: PropTypes.func,
  name: PropTypes.string,
  description: PropTypes.string,
  activity: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }),
  rating: PropTypes.number,
  isPrivate: PropTypes.bool
};

TrackUploadFields.defaultProps = {
  updateTrackForm: () => {},
  name: '',
  description: '',
  activity: {},
  rating: 0,
  isPrivate: false
};

export default TrackUploadFields;
